<script>

    import Spinner from './spinner.svelte'

    export let loading = false

</script>

<Spinner { loading } />

{#if !loading}
    <form on:submit|preventDefault on:submit>
        <slot></slot>
    </form>
{/if}
